import { fetchApi } from '@/config/axiosSetting';
import { PatchPropertyInsuranceType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchPropertyInsurance/patchPropertyInsurance.type';

export const patchPropertyInsuranceFunction = ({
  id,
  formData,
  damaged_id,
}: PatchPropertyInsuranceType) => {
  return fetchApi.patch(
    `/property/reports/${id}/accident_users/damaged/insurance_information/?damaged_id=${damaged_id}`,
    {
      ...formData,
    },
  );
};
